const { Box, styled } = require("@mui/material")

export const BookingPage = styled(Box)(() => ({
    padding: '80px 20px 20px 80px',
    position: 'absolute',
    width: '100%',
    height: '100%'
}))
